<template>
	<Modal :show-modal="showModal">
		<template v-slot:header>
			<div class="title">
				<img src="@/images/svg/alert.svg" alt="" />
				<h4 class="modal-title">{{ $t('dialog.service-termination-title') }}</h4>
			</div>
		</template>
		<template v-slot:body>
			<div class="body">
				{{ $t('dialog.service-termination-description') }}
			</div>
		</template>
		<div slot="footer">
			<div class="col-xs-12">
				<FormButton
					id="modalButtonID"
					class="btn-black"
					:label="$t('dialog.service-termination-button')"
					:button-click="closeModal"
				/>
			</div>
		</div>
	</Modal>
</template>
<script>
import { Modal, FormButton } from '@arena/toolkit';

export default {
	components: {
		Modal,
		FormButton,
	},
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		showModal(show) {
			if (show) {
				this.$a2s.view('charge_block_alert_imp');
			}
		},
	},
	methods: {
		closeModal() {
			const lang = this.$i18n.locale || 'th';
			location.href = location.origin + `/main/${lang}`;
		},
	},
};
</script>
<style lang="less" scoped>
.title {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
}

.modal-title {
	text-align: center;
}

.body {
	text-align: center;
	white-space: pre-line;
}
</style>
